import React__default from 'react';
import createSvgIcon from '../utils/createSvgIcon.js';
import '../SvgIcon-0b8a779c.js';
import 'classnames';

var MinusCircle = createSvgIcon(React__default.createElement(React__default.Fragment, null,
    React__default.createElement("circle", { cx: "12", cy: "12", r: "10", transform: "rotate(90 12 12)" }),
    React__default.createElement("path", { d: "M18 13L6 13V11L18 11L18 13Z", fill: "#fff" })), 'MinusCircle');

export { MinusCircle };
